/* global axios */
import { useAccount } from 'dashboard/composables/useAccount';

/**
 * Gate do "evento de conversão obrigatório" (Meta CAPI) no resolve.
 *
 * Espelha o useConversationRequiredAttributes, mas o estado vive no backend
 * (tabela meta_capi_configs + eventos por conversa). Consulta o endpoint da
 * conversa e diz se o resolve deve ser bloqueado até enviar o evento.
 */
export function useConversationRequiredCapiEvent() {
  const { accountId } = useAccount();

  /**
   * @returns {Promise<{required: boolean, satisfied: boolean, events: string[]}>}
   * required=false quando o CAPI não está ativo/exigido → nunca bloqueia.
   */
  const checkConversationCapi = async conversationId => {
    if (!conversationId)
      return { required: false, satisfied: true, events: [] };
    try {
      const { data } = await axios.get(
        `/api/v1/accounts/${accountId.value}/astrachat/conversations/${conversationId}/meta_capi`
      );
      const req = data?.data?.resolve_requirement || {};
      return {
        required: !!req.enabled,
        satisfied: req.satisfied !== false,
        events: req.events || [],
      };
    } catch (e) {
      // em erro, não bloqueia o resolve (fail-open)
      return { required: false, satisfied: true, events: [] };
    }
  };

  return { checkConversationCapi };
}
